import React, {useCallback, useEffect, useState} from 'react';
import UModal from 'ubs-framework/v2/UModal/NewUModal';
import useUAlert from "ubs-framework/v2/UAlert";
import * as Icon from "ubs-icons";
import {FILE} from "ubs-framework/v2/common/constant";
import {useSelector} from "react-redux";
import {useDropzone} from "react-dropzone";

import {api, sendData} from "../../../../store/actions";
import useSocket from "../../hooks/useSocket";
import VerifyTableData from "./common/verify-data-table";
import UploadFile from "./common/upload-file";
import ColumnMatchTable from "./common/column-match-table";
import SuccessDataTable from "./common/success-data-table";
import {getCookie} from "ubs-framework/v2/common/function";
import UFilterDownload from "../../filters/UFilterDownload";
import {isThisAFile} from "ubs-framework/v2/common/function";
import {getKeyValue, getLabelValue} from "ubs-framework/v2/common/function";

const CandidateFieldsImportExport = React.memo(({open, header, onClose,}) => {
    const alert = useUAlert()
    const _ORG_ID = useSelector(e => e.common.orgId);

    const _SL_LV = useSelector(e => getLabelValue(e?.hrms?.sourceList));
    const _A_LT_KV = useSelector(e => getKeyValue(e?.hrms?.branchList));
    const _A_JTL_KV = useSelector(e => getKeyValue(e?.hrms?.jobTitleList));
    const _FSL = useSelector(e => e.common?.settings?.maxFileSizeLimit);

    const [file, setFile] = useState('');
    const [finalData, SetFinalData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [ie, setIe] = useState({
        listOpen: false,
        done: 0,
        randomString: '',
        errorList: [],
        successData: [],
        alreadyRegistered: [],
        headers: [],
        HEADER: []
    });
    const [jobList, setJobList] = useState([]);
    const [updatedFields, setUpdatedFields] = useState([]);
    const [globalErrorList, setGlobalErrorList] = useState([]);
    const [step1ErrorFlag, setStep1ErrorFlag] = useState(true);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [activeTab, setActiveTab] = useState('error'); /** error/ success */

    useEffect(() => {
        refresh()
    }, [globalErrorList])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|job|nameList': {
                    setJobList(getLabelValue(res?.data?.list))
                    break;
                }
                case 'ats|candidate|insert':
                    // if (res?.data?.errorList?.length) {
                    setIe({
                        step: res?.data?.step,
                        errorList: res?.data?.errorList,
                        successData: res?.data?.successData,
                        randomString: res?.data?.randomString,
                    })

                    if (res?.data?.isSelected) setGlobalErrorList(globalErrorList ? [...globalErrorList, ...res?.data?.errorList] : [...res?.data?.errorList])
                    else setGlobalErrorList(res?.data?.errorList || [])

                    if (globalErrorList?.length === 0 && res?.data?.errorList?.length === 0) {
                        setIe({
                            ...ie,
                            step: 3,
                            successData: res?.data?.successData,
                        })
                        // onClose()
                    }
                    setButtonLoader(false)

                    // } else {
                    //     // getEmployeeData()
                    //     // setButtonLoader(false)
                    //     // showToastSuccess(`Employee Import Successfully.`)
                    //     // onClose()
                    // }
                    break;
                default:
                    return true;
            }
        } else {
            switch (res.code) {
                case 400:
                case 412:
                case 500:
                    setButtonLoader(false)
                    break;
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        sendData('ats|job|nameList', {})
    }, [])

    const onDrop = useCallback(acceptedFiles => {
        if (FILE.ELSXFILES.exec(acceptedFiles[0]?.name)) {
            let sizeError = false;
            sizeError = acceptedFiles[0].size / 1024 / 1024 > 10;
            if (!sizeError) {
                setFile(acceptedFiles)
                prepareFiles(acceptedFiles);
            } else {
                alert.show({title: 'Something went wrong.', description: `Files must smaller than 10 MB!`})
            }
        } else {
            alert.show({title: 'Something went wrong.', description: 'Unsupported File.'})
        }
    }, []);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        multiple: false,
        accept: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const prepareFiles = async (data) => {
        if (data.length <= 1) {
            let sizeError = false;
            const fileArray = Object.assign([], data);
            for (let i = 0; i < fileArray.length; i++) {
                if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > _FSL;
            }

            if (!sizeError) {
                let myFiles = [];
                const number = data.length;
                for (let i = 0; i < number; i++) {
                    const name = fileArray[i]?.name?.split('.');
                    const ext = name[name.length - 1];
                    if (FILE.ELSXFILES.exec(fileArray[i]?.name)) {
                        if (!FILE.EXCLUDES.includes(ext)) {
                            await isThisAFile(fileArray[i]).then(validFile => {
                                myFiles.push(validFile);
                            }).catch(error => {
                            });
                            uploadCSV(myFiles)
                        }
                    } else {
                        alert.show({title: 'Something went wrong.', description: 'Unsupported File.'})
                    }
                }

            } else {
                setFile(null);
                alert.show({title: 'Something went wrong.', description: `Files must smaller than 10 MB!`})
            }
        } else {
            alert.show({title: 'Something went wrong.', description: 'You can only upload one file at a time.'})
            setFile('');
        }
    };

    const uploadCSV = (files) => {
        if (!loader) {
            setLoader(true)
            const body = {
                event: 'ats|candidate|import',
                data: {},
                orgId: _ORG_ID
            };
            const formData = new FormData();
            formData.append('body', JSON.stringify(body));
            formData.append('file', files[0]);

            const config = {
                headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                onUploadProgress: e => {
                },
            };
            api.post('/hrmsFileUploads', formData, config).then(res => { //fileUpload , hrmsFileUpload
                setLoader(false)
                if (res?.data?.data?.statusCode === 500) {
                    alert.show({title: 'Something went wrong.', description: res?.data?.data?.error})
                }
                if (res?.data) {
                    setIe({
                        ...ie,
                        listOpen: true,
                        done: res?.data?.data?.done,
                        errorList: res?.data?.data?.errorList || [],
                        successData: res?.data?.data?.successData || [],
                        alreadyRegistered: res?.data?.data?.alreadyRegistered || [],
                        headers: res?.data?.data?.headers || [],
                        randomString: res?.data?.data?.randomString || '',
                        HEADER: res?.data?.data?.HEADER?.map(e => {
                            e.label = e.key
                            e.value = e.key
                            return e
                        }) || [],
                        step: res?.data?.data?.errorList?.length === 0 ? 3 : res?.data?.data?.step
                    })

                    setGlobalErrorList(res?.data?.data?.errorList)

                    setUpdatedFields(res?.data?.data?.headers || [])
                    let index = res?.data?.data?.headers.findIndex(_ => _?.mainKey === '')
                    setStep1ErrorFlag(index !== -1)
                }
            }).catch(error => {
                setLoader(false)
            })
        }
    }

    const onDragEnter = (event) => {
        if (event.target.className === "u_org-dashboard" || "u_upload-file-inner") {
            // event.target.style.border = "3px dotted red";
        }
    }

    const dragLeave = (event) => {
        if (event.target.className === "u_org-dashboard" || "u_upload-file-inner") {
            event.target.style.border = "";
        }
    }

    const handle = {
        change: (e, key) => {
            let data = JSON.parse(JSON.stringify(updatedFields))
            data = data?.map((d, i) => {
                if (key === d?.fileKey) d = {...d, mainKey: e?.value, isRequired: e?.isRequired}
                return d
            })
            setUpdatedFields(data);
            let index = data?.findIndex(_ => _?.mainKey === '')
            setStep1ErrorFlag(index !== -1)
        },
        matchData: e => {
            let data = {
                randomString: ie?.randomString,
            }
            if (ie?.step === 1) {
                data.step = 1
                data.headers = []
                Object.keys(updatedFields)?.map(d => {
                    return data.headers.push({
                        fileKey: updatedFields[d]?.fileKey,
                        mainKey: updatedFields[d]?.mainKey,
                        isRequired: updatedFields[d]?.isRequired
                    })
                })
                setButtonLoader(true)
                sendData('ats|candidate|insert', data);

            } else if (ie?.step === 2) {
                data.step = 2
                data.list = []
                data.employeeIds = []
                let finalList = [], empID = []

                if (finalData?.length) {
                    /** success key for remove success data from listing */
                    finalData?.filter(_ => _.success)?.map(d => {
                        delete d.error
                        empID.push(d?.uuidv4)
                        d.dob = new Date(d?.dob).getTime()

                        d.source = _SL_LV?.find(_ => _?.name === d?.source)?.label
                        d.location = _A_LT_KV[d?.['locationId']]
                        d.jobTitle = _A_JTL_KV[d?.['jobTitleId']]
                        if(d?.expectedCtcType === 2) d.expectedCtcRange = {from: d?.expectedCtcFrom, to: d?.expectedCtcTo, expectedCtc: null}
                        Object.entries(d).forEach(o => (o[1] === null ? delete d[o[0]] : 0))
                        return finalList.push(d)
                    })
                    data.employeeIds = empID
                    data.list = finalList
                    setButtonLoader(true)
                    setGlobalErrorList(finalData?.filter(_ => !_.success))
                    if (finalList.length) sendData('ats|candidate|insert', data);
                    else {
                        setButtonLoader(false)
                        alert.show({title: 'Something went wrong.', description: `Please update sheet data.`})
                    }

                    // if (finalList.length) sendData('ats|candidate|insert', data);
                    // else alert.show({title: 'Something went wrong.', description: `Please update sheet data.`})
                } else {
                    setButtonLoader(false)
                    /** added condition for check error list and show alert message */
                    if (ie?.errorList?.length && globalErrorList.length) {
                        alert.show({title: 'Something went wrong.', description: `Please update sheet data.`})
                        setButtonLoader(false)
                    } else {
                        setIe({
                            ...ie,
                            step: 3,
                        })
                    }
                }
            }
        }
    }

    return (
        <React.Fragment>
            {open &&
            <UModal
                open={open}
                maxWidth={`calc(100% - 90px)`}
                className="u_import-sidemodal"
                onClose={onClose}
                confirmationOnClose
                header={<h4>{header}</h4>}
                position="right"
                confirmationTitle="Something went wrong."
                confirmationDescription={`Are you sure want to close Import Candidate Data?`}
            >
                <React.Fragment>
                    <div className="u_common-import">
                        <div className={`u_import-step u_p-20 u_border-bottom ${ie?.step === 1 ? 'u_pb-20' : ''}`}>
                            <div className="u_flex u_align-center u_content-between">

                                <ul className="u_flex u_policy-header-timeline">
                                    <li className={`u_text-center u_relative ${(!ie?.step || ie?.step === 1 || ie?.step === 2 || ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">1</span>
                                        <p>Import Sheet</p>
                                    </li>
                                    <li className={`u_text-center u_relative ${(ie?.step === 1 || ie?.step === 2 || ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">2</span>
                                        <p>Match Column</p>
                                    </li>

                                    <li className={`u_text-center u_relative ${(ie?.step === 2 || ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">3</span>
                                        <p>Preview Data</p>
                                    </li>
                                    <li className={`u_text-center u_relative ${(ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">4</span>
                                        <p>Result</p>
                                    </li>
                                </ul>

                                <div className="u_common-import-btn">
                                    {!ie?.step && <UFilterDownload data={[{
                                        type: 'XLS',
                                        label: 'Download Sample',
                                        event: 'ats|candidate|sampleCsv',
                                        data: {orgId: _ORG_ID}
                                    }]} iconBg={true} name=" "/>}
                                    {(ie?.step && ie?.step !== 3) && <button
                                        type="submit"
                                        className={`u_btn u_btn__smallBtn u_btn__blue`}
                                        // disabled={step1ErrorFlag || buttonLoader}
                                        onClick={() => handle.matchData()}>Continue
                                    </button>}
                                    {buttonLoader && <div className="u_flex u_content-end"><Icon.Preloader size={40}/></div>}
                                    {ie?.step === 3 && <h4>Data Import Finished</h4>}
                                </div>
                            </div>
                        </div>

                        {/** steppers for step 2 & 3 */}
                        {ie?.step === 2 && <div className="u_route-tabs u_bb-light" id="u_route-tabs">
                            <ul className="u_flex u_align-center">
                                <li onClick={() => setActiveTab('error')}>
                                    <a className={`${activeTab === 'error' ? 'active' : ''}`}>Error
                                        {!!finalData?.length && <div className="u_badge u_ml-3">
                                            <label className="u_badge-inner">{finalData?.length}</label>
                                        </div>}
                                    </a>
                                </li>
                                <li onClick={() => setActiveTab('success')}>
                                    <a className={`${activeTab === 'success' ? 'active' : ''}`}>Success
                                        {!!ie?.successData?.length && <div className="u_badge u_ml-3">
                                            <label className="u_badge-inner">{ie?.successData?.length}</label>
                                        </div>}
                                    </a>
                                </li>
                            </ul>
                        </div>}

                        {![1, 2, 3].includes(ie?.step) && <UploadFile
                            dragLeave={(e) => dragLeave(e)}
                            onDragEnter={(e) => onDragEnter(e)}
                            getInputProps={getInputProps}
                            getRootProps={getRootProps}
                            file={file}
                            loader={loader}
                        />}

                        {ie?.step === 1 && <ColumnMatchTable
                            ie={ie}
                            updatedFields={updatedFields}
                            handle={handle}
                        />}

                        {(ie?.step === 2 && activeTab === 'error') && <VerifyTableData
                            errorList={ie?.errorList}
                            originalErrorList={ie?.errorList}
                            globalErrorList={globalErrorList}
                            randomString={ie?.randomString}
                            FinalData={(e) => SetFinalData(e)}
                            setGlobalErrorList={(e) => setGlobalErrorList(e)}
                            activeTab={activeTab}
                            jobList={jobList}
                        />}

                        {((ie?.step === 2 && activeTab === 'success') || ie?.step === 3) && <SuccessDataTable
                            successData={ie?.successData}
                            jobList={jobList}
                        />}

                    </div>
                </React.Fragment>
            </UModal>
            }
        </React.Fragment>
    );
});

export default CandidateFieldsImportExport;
